import Chip from "@mui/material/Chip"
import Link from "@mui/material/Link"
import Typography from "@mui/material/Typography"

import Column from "../../../common/components/Column"
import Row from "../../../common/components/Row"

const SUPPORT_EMAIL = "support@onebasecrm.com"

export function SupportLink({ children = "contact support" }) {
  return (
    <Link href={`mailto:${SUPPORT_EMAIL}`} color="primary">
      {children}
    </Link>
  )
}

/** Plain-English rejection reasons with the fields to fix. */
export function A2PFailureList({ failures }) {
  if (!failures?.length) {
    return (
      <Typography variant="body2">
        The carrier registry didn't give a reason. Please <SupportLink /> and
        we'll look into it with you.
      </Typography>
    )
  }
  return (
    <Column sx={{ gap: 1.5, alignItems: "flex-start" }}>
      {failures.map((failure, i) => (
        <Column key={i} sx={{ gap: 0.5, alignItems: "flex-start" }}>
          <Typography variant="body1" sx={{ fontWeight: 700 }}>
            {failure.title}
          </Typography>
          {failure.detail && failure.detail !== failure.title && (
            <Typography variant="body2" color="text.secondary">
              Carrier registry said: "{failure.detail}"
            </Typography>
          )}
          {failure.fields?.length > 0 && (
            <Row sx={{ gap: 0.5, flexWrap: "wrap" }}>
              <Typography variant="body2" sx={{ mr: 0.5 }}>
                Check:
              </Typography>
              {failure.fields.map((field) => (
                <Chip
                  key={field.name}
                  size="small"
                  color="error"
                  variant="outlined"
                  label={field.label}
                />
              ))}
            </Row>
          )}
          <Typography variant="body2">{failure.fix}</Typography>
        </Column>
      ))}
    </Column>
  )
}
